import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-progress',
    templateUrl: './progress.component.html',
    styleUrls: ['./progress.component.less'],
})
export class ProgressComponent implements OnInit{
    @Input() percent: number | undefined;
    @Input() strokeWidth = 4;
    @Input() nzType = 'line';
    @Input() showInfo = false;
    @Input() strokeLinecap = 'round';
    @Input() nzStrokeColor: any = { '0%': '#FFA14B', '100%': '#FF902B' };
    @Input() class!: string;
    @Input() textHasColor = false;
    className!: string;

    ngOnInit(): void {
        this.className = this.getClassName();
    }

    getClassName(): string {
        let className = '';
        if (this.textHasColor) {
            const value = this.percent as number;
            if (value < 75 && value >= 50) {
                className += ' orange-text';
            } else if (value < 100 && value >= 75) {
                className += ' yellow-text';
            } else if (value === 100){
                className += ' green-text';
            } else if (value === 0) {
                return className;
            } else {
                className += ' red-text';
            }
        }
        return this.class ? this.class + '' + className : className;
    }
}
